import * as React from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Box, Grid, Hidden, Typography } from "@material-ui/core";
import { BoxProps } from "@material-ui/core/Box";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import { MUICourseGroupDefaultIcon } from "../../../MUI";
import { useTheme } from "@material-ui/core/styles";
import * as styles from "../styles.scss";
import { SvgIcon } from "../../../../../components";
import { tl } from "../../../../../utils";
import { themeVariables } from "../../_Theme";

interface IProps extends BoxProps {
  group: any;
  showIconLabel?: boolean;
  onConvertGroup?: (group_id: number) => void;
  isEditable?: boolean;
  extended?: boolean;
  toggleGroupExtend?: (e?: any) => void;
  styleExtend?: boolean;
}

export const GroupCover = (props: IProps) => {
  const {
    group,
    extended,
    showIconLabel,
    onConvertGroup,
    isEditable,
    toggleGroupExtend,
    styleExtend,
    children,
  } = props;
  const theme = useTheme();
  const history = isEditable ? useHistory() : null;

  const settingsLink = `/panel/courses/group/group_id/${group.id}`;

  const isConvertGroup =
    onConvertGroup &&
    group.groupType !== "subscribe" &&
    group.groupType !== "shop" &&
    group.id !== -1 &&
    !group.authorName;

  const onCoverClick = isConvertGroup
    ? () => onConvertGroup(group.id)
    : isEditable
    ? () => history.push(settingsLink)
    : toggleGroupExtend;

  const groupSettings = isEditable ? (
    <Box clone bgcolor={theme.palette.grey.A100}>
      <Grid
        item
        title={tl("Настройки папки")}
        component={isConvertGroup ? Link : "div"}
        to={isConvertGroup ? settingsLink : ""}
        className={`react-hideBgOnHover ${styles.controlOuter}`}
      >
        <Box
          className={`${styles.settings} ${styles.controlInner}`}
          borderRight={themeVariables.border}
          borderLeft={isConvertGroup ? themeVariables.border : ""}
        >
          <SvgIcon type="courses-settings" />
        </Box>
      </Grid>
    </Box>
  ) : null;

  const iconLabel = ["subscribe", "shop"].includes(group.groupType)
    ? "courses-group" + group.groupType
    : null;

  return (
    <Box onClick={() => (onCoverClick ? onCoverClick() : null)}>
      <Box
        clone
        minHeight={55}
        bgcolor={
          !styleExtend || group.authorName ? theme.palette.grey.A100 : undefined
        }
      >
        <Grid
          container
          alignItems="center"
          wrap="nowrap"
          className={
            !styleExtend || group.authorName ? `react-hideBgOnHover` : ""
          }
        >
          <Box clone bgcolor={styleExtend ? theme.palette.grey.A100 : ""}>
            <Grid
              item
              component={!isConvertGroup && isEditable ? Link : "div"}
              to={!isConvertGroup && isEditable ? settingsLink : ""}
              onClick={isConvertGroup ? () => onConvertGroup(group.id) : null}
              xs
              zeroMinWidth
              className={`${styles.blockLink} react-hideBgOnHover ${
                styleExtend ? styles.controlOuter : ""
              }`}
            >
              <Grid
                container
                alignItems="center"
                wrap="nowrap"
                className={styleExtend ? `react-hideBgOnHover` : ""}
              >
                <Hidden only="xs">
                  <Grid item>
                    <Box
                      className={styles.groupIcon}
                      ml={1.5}
                      bgcolor="grey.A200"
                      borderRadius={themeVariables.buttonsRadius}
                      title={
                        group.groupType === "subscribe"
                          ? tl("Подписка")
                          : group.groupType === "shop"
                          ? tl("Магазин")
                          : null
                      }
                    >
                      {showIconLabel && iconLabel && group.icon ? (
                        <Box className={styles.groupIconLabel}>
                          <SvgIcon type={iconLabel} />
                        </Box>
                      ) : null}
                      {group.icon ? (
                        group.icon === "garbage" ? (
                          <SvgIcon type="coursegroup trash" />
                        ) : (
                          <img
                            src={`/media/192/${window.btoa(group.icon)}`}
                            alt=""
                            width="96"
                            height="60"
                          />
                        )
                      ) : group.groupType === "shop" ? (
                        <MUICourseGroupDefaultIcon
                          type="courses-groupshop big"
                          bgColor={themeVariables.palette.shop.main}
                        />
                      ) : group.groupType === "subscribe" ? (
                        <MUICourseGroupDefaultIcon
                          type="courses-groupsubscribe big"
                          bgColor={themeVariables.palette.subscribe.main}
                        />
                      ) : (
                        <SvgIcon type="coursegroup" />
                      )}
                    </Box>
                  </Grid>
                </Hidden>
                <Grid item xs zeroMinWidth className={styles.groupName}>
                  <Typography
                    variant="subtitle1"
                    style={{ color: theme.palette.grey[50] }}
                  >
                    <Box
                      fontWeight={600}
                      className={
                        group.authorName || group.subtitle
                          ? styles.groupNameSingle
                          : styles.groupNameDouble
                      }
                      title={group.name}
                    >
                      {group.name}
                    </Box>
                  </Typography>
                  {group.subtitle || group.authorName ? (
                    <Box
                      clone
                      className={styles.groupSubtitle}
                      color="grey.600"
                    >
                      <Typography variant="subtitle2">
                        {group.subtitle || group.authorName}
                      </Typography>
                    </Box>
                  ) : null}
                </Grid>
                {groupSettings ? groupSettings : null}
              </Grid>
            </Grid>
          </Box>
          {groupSettings ? groupSettings : null}
          {children}
          {toggleGroupExtend ? (
            <Box clone bgcolor={styleExtend ? theme.palette.grey.A100 : ""}>
              <Grid
                item
                onClick={(e) => {
                  e.stopPropagation();
                  toggleGroupExtend();
                }}
                className={
                  styleExtend
                    ? `react-hideBgOnHover ${styles.controlOuter}`
                    : ""
                }
              >
                <Box
                  clone
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-end"
                  className={`${styles.expand} ${styles.controlInner}`}
                  borderLeft={styleExtend ? themeVariables.border : ""}
                >
                  <Typography variant="subtitle1">
                    {extended ? (
                      <KeyboardArrowUp
                        fontSize="large"
                        style={{ color: theme.palette.primary.light }}
                      />
                    ) : (
                      <KeyboardArrowDown
                        fontSize="large"
                        style={{ color: theme.palette.primary.light }}
                      />
                    )}
                    <Box
                      className={`${
                        group.id !== -1
                          ? styles.countWrap
                          : styles.countWrapGarbage
                      }`}
                    >
                      <Grid
                        container
                        alignItems="center"
                        spacing={1}
                        wrap="nowrap"
                      >
                        <Grid item>{group.count}</Grid>
                        <Grid item>
                          <SvgIcon type="coursecount" />
                        </Grid>
                      </Grid>
                    </Box>
                  </Typography>
                </Box>
              </Grid>
            </Box>
          ) : (
            <Box className={`${styles.controlInner}`}></Box>
          )}
        </Grid>
      </Box>
    </Box>
  );
};
